const generalErrorMap = {
  NameExceededMaxLen: _TL_('Name exceeds the limit of 255 characters.'),
  DescriptionExceededMaxLen: _TL_('Description exceeds the limit of 2048 characters.'),
  CampaignAssociationsLimitExceeded: _TL_('Campaign association exceeds the limit of 2,000.'),
  InvalidDateTime: _TL_('Date range is not valid. End date should be after the start date.'),
  InvalidDateRange: _TL_('Date range is not valid. Enter a date range that is 14 days or less.'),
  DeviceTypeFilterIsNullOrEmpty: _TL_('Device is required. Select one or more devices.'),
  SeasonalityAdjustmentIsNull: _TL_('Conversion rate is required. Enter a percentage.'),
  InvalidAdjustmentPercentage: _TL_('Percentage is not valid. Enter a conversion rate between -90% and 900%.'),
};

export const seasonalityErrorMap = {
  ...generalErrorMap,
  EntityDoesNotExist: _TL_('This seasonality adjustment does not exist.'),
  InvalidSeasonalityAdjustmentId: _TL_('This seasonality adjustment does not exist.'),
  NameIsNullOrEmpty: _TL_("Seasonality adjustment Name can't be empty."),
  InvalidCampaignAssociationsAndCampaignTypeFilterCombination: _TL_("Seasonality adjustment campaign associations and campaign type filter can't both be empty or both not empty."),
};

export const dataExclusionErrorMap = {
  ...generalErrorMap,
  EntityDoesNotExist: _TL_('This data exclusion does not exist.'),
  InvalidSeasonalityAdjustmentId: _TL_('This data exclusion does not exist.'),
  NameIsNullOrEmpty: _TL_("Data exclusion Name can't be empty."),
  InvalidCampaignAssociationsAndCampaignTypeFilterCombination: _TL_("Data exclusion campaign associations and campaign type filter can't both be empty or both not empty."),
};
